export const zh = {
  app: {
    tabs: {
      club: '社团事宜',
      activity: '活动事宜',
      feedback: '意见反馈',
      feedbackCollection: '反馈收集',
      audit: '审核状态',
    },
    search: {
      placeholder: '快速搜索用户 ID、社团或活动...',
      button: '搜索',
      resultTitle: '搜索结果',
      backHome: '返回主页',
    },
    users: '用户',
    clubs: '社团',
    activities: '活动',
    noUsers: '未找到匹配用户',
    noClubs: '无相关社团',
    noActivities: '无相关活动',
    setAdmin: '设为管理员',
    cancelRole: '取消权限',
    save: '保存',
    englishName: '英文名',
    logout: '退出',
    name: '姓名',
    class: '班级',
    langSwitch: 'English',
  },
  common: {
    back: '返回',
    cancel: '取消',
    submit: '提交',
    confirm: '确定',
    close: '关闭',
    save: '保存',
    edit: '编辑',
    delete: '删除',
    loading: '加载中...',
    success: '成功',
    fail: '失败',
    people: '人',
    capacity: '人数',
    full: '人数已满',
    block: '时段',
    clubs: '个社团',
  },
  club: {
    menu: '我的社团状态',
    wednesday: '周三社团',
    wednesdayHint: '（最多 4 时段，至少 2 个社团）',
    daily: '日常社团',
    notJoined: '暂未加入',
    usedSlots: '已选',
    slotsTotal: '4 时段',
    needTwo: '至少需选 2 个周三社团',
    leave: '退出',
    rotation: '社团轮换',
    rotationHint: '仅周三社团',
    registration: '社团报名',
    registrationHint: '日常 / 周三',
    creation: '社团创建',
    backMenu: '返回菜单',
    searchClub: '搜索社团名称，选择后可直接查看或报名',
    searchRotation: '搜索社团名称，选择后可直接更换或查看',
    dailyClubs: '日常社团（周三除外，可报多个）',
    wednesdayClubs: '周三社团（最多 4 时段，至少 2 个社团，每时段只能选一个）',
    noDaily: '暂无日常社团',
    noWednesday: '暂无周三社团',
    join: '立即报名',
    alreadyOrConflict: '已选或时段冲突',
    detail: '社团详情',
    participants: '参与人员',
    rollCall: '点名记录',
    venue: '场地申请与排期',
    downloadExcel: '下载成员Excel',
    dissolve: '解散社团',
    closeDetail: '关闭详情',
    categoryTypeIntro: '社团分类、类型与介绍',
    creator: '创建者',
    actualLeader: '负责人',
    proxyCreated: '代理创建',
    wednesdayClub: '周三社团',
    dailyClub: '日常社团',
    both: '周三+日常',
    academic: '学术社团',
    activityType: '活动社团',
    replaceWith: '更换为此社团',
    quotaUsed: '轮换次数已用完',
    resetQuota: '重置本学期次数',
    replaceWhich: '选择要替换的社团',
    replaceHint: '将您当前的一个周三社团更换为刚选择的社团',
    rotationTime: '开放时间：周日 17:00 - 周四 21:50',
    semesterUsed: '本学期已轮换',
    times: '次',
    quotaExhausted: '本学期轮换次数已用完，无法继续轮换，请等待下一学期。',
    needOneWednesday: '请先报名至少一个周三社团才能进行轮换',
    createApply: '发起社团创建申请',
    blocks: '活动板块',
    intro: '一句话介绍社团...',
    content: '主要活动内容...',
    members: '参与人员',
    coreMembers: '核心人员',
    viewDetail: '查看详情',
    searchCoreMember: '搜索姓名或ID添加核心人员',
    noMembers: '暂无成员',
    introLabel: '介绍',
    categoryLabel: '分类',
    typeLabel: '类型',
    blocksAndTime: '板块与时间',
    finalConfirm: '最终确认',
    finalConfirmMessage: '确定当前周三社团的选择吗？确认后将无法直接退出社团，只能通过社团轮换改变组合。',
    finalConfirmDone: '已最终确认，如需更改请使用社团轮换',
    addUser: '添加用户',
    searchNameOrId: '搜索姓名或ID',
    add: '添加',
    transferFounder: '转交创建者身份',
    transfer: '转交',
  },
  activity: {
    ongoing: '正在进行的活动',
    searchActivity: '搜索活动名称，选择后直接进入报名',
    noMatch: '无匹配活动',
    organizer: '组织者',
    youAreOrganizer: '您是组织者',
    register: '去报名',
    registerTitle: '活动报名',
    reason: '申请原因',
    contact: '联系方式',
    participants: '参与人员',
    phase: '阶段',
    location: '地点',
    time: '时间',
    description: '简介',
    fee: '报名费',
    paymentQR: '支付二维码',
    payBefore: '请扫描下方二维码完成支付',
    uploadProof: '上传支付凭证',
    deleteActivity: '删除活动',
    organize: '发起活动',
    back: '返回',
    organizeBtn: '1. 活动组织',
    registerBtn: '2. 活动报名',
    allActivitiesList: '所有活动列表',
    noActivities: '暂无活动',
    phasePrep: '活动准备',
    phaseStart: '活动开始',
    phaseInProgress: '活动中',
    phaseEnd: '活动结束',
    prepTime: '准备时间',
    startTime: '开始时间',
    inProgressTime: '进行时间',
    endTime: '结束时间',
    downloadParticipantsExcel: '下载参与者Excel',
    viewScreenshot: '查看截图',
    totalParticipants: '共 {count} 位参与者',
    noParticipants: '暂无参与者',
    regActivity: '报名活动',
    joinClub: '加入',
    organizeTitle: '组织活动',
    requiredStarHint: '标有 * 的为必填项',
    activityNameLabel: '活动名称',
    activityNamePlaceholder: '活动名称',
    capacityLabel: '人数上限',
    capacityPlaceholder: '人数',
    locationLabel: '地点',
    locationPlaceholder: '地点',
    shortDescLabel: '简要描述',
    shortDescPlaceholder: '简要描述',
    flowLabel: '活动流程',
    flowPlaceholder: '活动流程（不需要填写具体时间）',
    requirementsLabel: '活动需求',
    requirementsPlaceholder: '活动需求',
    timeSectionTitle: '活动时间',
    timeSectionHint: '必填：请填写本场活动的开始与结束时间（结束须晚于开始）',
    startLabel: '开始',
    endLabel: '结束',
    perfCheckboxLabel: '本活动为演出（参与者选座购票）',
    perfCheckboxHint: '开启后活动审核通过，请在「活动详情」中编辑座位区域、排数、座位数与分区票价。若分区票价或全局报名费需线上收款，请勾选下方报名费并上传收款码。',
    feeOptionalLabel: '报名费（可选）',
    feeAmountLabel: '费用金额',
    feeAmountPlaceholder: '例如：50元 或 100元',
    uploadQRLabel: '上传支付二维码',
    uploadQRHint: '（微信/支付宝二维码）',
    uploadQRWarn: '⚠️ 请上传支付二维码',
    attachmentOptional: '上传活动附件 (可选)',
    submitActivityApply: '提交活动申请',
    introShort: '简介',
    confirmedSeats: '已确认座位',
    mySeatPrefix: '我的座位：',
    mySeatApproved: '（已确认）',
    mySeatPending: '（待审核）',
    feeInfoPrefix: '💰 报名费:',
    feeNotSet: '未设置',
    editPerformanceSeats: '编辑演出座位',
    perfSeatTag: '演出 · 选座',
    perfSeatTagDetail: '演出 · 选座',
    perfChooseSeatTitle: '本活动为演出，请使用右侧「选座报名」',
    chooseSeatRegister: '选座报名',
    organizerColon: '组织者:',
    introColon: '简介:',
    deleteConfirm: '确定要删除此活动吗？所有参与者将自动解散。',
    deleted: '活动已删除',
    errLoadSeat: '加载座位失败',
    successLocksSaved: '预留座位已保存',
    errSaveLocks: '保存失败',
    errDownload: '下载失败',
    errMinZoneRow: '请至少添加一个区域和一行座位',
    errSeatZero: '座位数为 0，请检查每排座位数',
    errBulkZone: '请先添加至少一个分区',
    errBulkRange: '请填写有效的排号范围（起≤止）与每排座位数（≥1）',
    errSaveLayout: '保存失败',
    errSaveLayoutOk: '座位图与内部票设置已保存并发布',
    errUploadProofFirst: '请先上传付款截图',
    uploadProofRequiredWarn: '⚠️ 请上传支付截图',
    reserveSubmitted: '选座申请已提交，请等待组织者确认收款',
    reserveFail: '提交失败',
    errCapacityInt: '人数须为大于等于 1 的整数',
    errMissingPrefix: '请填写必填项：',
    errNeedQRIfFee: '选择了报名费功能，必须上传支付二维码',
    errFillTime: '请填写活动开始时间与结束时间',
    errInvalidTime: '活动时间格式无效，请重新选择',
    errEndAfterStart: '结束时间必须晚于开始时间',
    activitySubmitted: '活动申请已提交，请等待审核',
    submitFail: '提交失败',
    errNeedFeeProof: '该活动需要支付报名费，请上传支付截图',
    regSubmitted: '报名申请已提交，请等待组织者审核',
    regFail: '报名失败',
    participantsLoadFail: '获取参与者列表失败',
    updated: '更新成功',
    updateFail: '更新失败',
    deleteFail: '删除失败',
    participantsTitle: '参与人员',
    participantsPageTitle: '参与人员 - {name}',
    serialNo: '序号',
    userIdCol: '用户ID',
    paymentProofCol: '支付凭证',
    totalParticipantsLine: '共 {n} 位参与者',
    performanceLockTitle: '预留座位（内部票） · ',
    performanceBookTitle: '选座 · ',
    backToList: '返回列表',
    lockHelp: '点击座位可在「开放选座」与「预留（对外显示为已售）」之间切换。已有选座/待审的座位不可改；已占座位可点击查看选座人姓名与班级。完成后点底部「保存预留」。',
    bookHelp: '每位用户仅限选择一个座位；提交后不可再选其他座（待审或已确认均算已占用）。若与他人同时选同一座，后提交者将提示「此位置已被选择」。',
    myCurrentPick: '您当前选座：',
    pendingReview: '（审核中）',
    confirmed: '（已确认）',
    legendLock: '绿色：将开放｜紫色：预留（对外显示为已售）｜其他颜色：已有选座记录，不可改',
    legendBook: '绿色：可选｜橙色：他人待审｜深黄：我的待审｜蓝色：我已确认｜灰色：已售或预留',
    legendOrg: '组织者/管理员：点击已占座位（橙/黄/蓝/灰格）可查看该座选座人的姓名与班级。',
    loadingSeats: '加载座位中…',
    saveLocksBtn: '保存预留',
    currentReserved: '当前预留 {n} 座',
    confirmSeatTitle: '确认选座',
    seatLine: '座位：{z} {r}排 {s}号',
    amountLine: '金额：¥{p}',
    scanPayThenUpload: '请扫码支付后上传截图',
    submitRequest: '提交申请',
    holderTitle: '选座人信息',
    reviewStatusLabel: '审核状态：',
    statusApproved: '已通过',
    statusPending: '待审核',
    nameLabelPlain: '姓名：',
    classLabelPlain: '班级：',
    clickHolder: '点击查看选座人姓名与班级',
    rowSuffix: '排',
    seatCellHeld: '占',
    seatCellPending: '审',
    seatCellReserved: '预',
    seatCellSold: '售',
    regFormTitle: '活动报名: {name}',
    detailTitle: '活动详情 - {name}',
    edit: '编辑',
    notFilled: '（未填写）',
    introHeading: '活动简介',
    flowHeading: '活动流程',
    reqHeading: '活动需求',
    locationStrong: '地点：',
    timeStrong: '活动时间：',
    organizerStrong: '组织者：',
    peopleStrong: '人数：',
    capacityUnlimited: '（不限制）',
    feeStrong: '💰 报名费：',
    mySeatDetail: '我的座位：',
    hintMapSeat: '在「选座报名」中可查看座位图上的位置。',
    reserveSeatsInternal: '预留座位（内部票）',
    selectSeatToRegister: '选座报名',
    seatEditorTitle: '编辑演出座位 · {name}',
    seatStepLayout: '（1/2 排布）',
    seatStepPreview: '（2/2 预览与内部票）',
    seatHowToTitle: '怎么用：',
    seatHowTo1: '分区：区名 + 单价（元/座）。',
    seatHowTo2: '排：可「+ 一排」逐排添加，或用下方「一键加多排」批量添加。',
    seatHowTo3: '填完后点「下一步」：在预览里标记内部票（预留），再点「保存并发布」后观众才能选座；避免先发布后内部票被抢。',
    seatHowTo4: '发布后仍可在活动列表进入「预留座位（内部票）」微调（入口保留）。',
    zoneHeading: '分区',
    addZone: '+ 分区',
    newZoneDefault: '新区',
    zoneNameCol: '分区名称',
    pricePerSeat: '单价（元/座）',
    zoneNamePlaceholder: '区名 如一楼',
    pricePlaceholder: '票价',
    bulkTitle: '一键加多排',
    bulkHint: '同一分区下，从「起排」到「止排」连续添加，每排座位数相同（排号为数字 1、2、3…）。',
    bulkZone: '分区',
    rowFrom: '起排',
    rowTo: '止排',
    seatsPerRow: '每排几座',
    bulkAddBtn: '添加这些排',
    rowsManualTitle: '排 · 座位数（逐排）',
    addOneRow: '+ 一排',
    colBelongZone: '所属分区',
    colRowLabel: '排号',
    colSeatCount: '本排座位数',
    rowPlaceholder: '如 1、A',
    seatCountPlaceholder: '几座',
    delete: '删',
    selectZoneTitle: '这排属于哪个分区（票价沿用该分区）',
    rowLabelTitle: '选座图上这一排的标识',
    seatCountTitle: '这一排连续有多少个座位',
    nextPreview: '下一步：预览并设置内部票',
    previewHint: '点击座位可在开放选座（绿）与内部预留（紫）之间切换。确认后点「保存并发布」——将同时保存座位图与内部票，观众端才会开放选座。',
    lockedCount: '当前内部预留 {n} 座',
    savePublish: '保存并发布',
    prevStep: '上一步',
    seatToggleLockTitle: '点击改为内部预留',
    seatToggleOpenTitle: '点击改为开放选座',
    feeInfoTitle: '💰 报名费信息',
    feeAmountStrong: '费用金额：',
    payScanLine: '请扫描下方二维码完成支付：',
    paymentScreenshot: '付款截图',
    fileSelected: '✅ 已选择文件: {name}',
    submitRegister: '提交报名',
    editName: '活动名称',
    editLoc: '地点',
    editTime: '活动时间',
    editTimePlaceholder: '例：2026/4/1 08:00:00 - 2026/4/8 09:00:00',
    editCapHint: '人数上限（留空表示不限制）',
    editDesc: '活动简介',
    editFlow: '活动流程',
    editReq: '活动需求',
    feeCheckboxEdit: '收取报名费',
    feeAmountEdit: '报名费金额',
    feeExamplePlaceholder: '如：50元',
    paymentQRAlt: '支付二维码',
    fileSelectedShort: '已选择文件',
    youAreOrganizerShort: '您是组织者',
    excelNameFallback: '活动',
    participantsExcelSuffix: '参与者名单.xlsx',
    defaultZoneFloor: '一楼',
    missingFieldActivityName: '活动名称',
    missingFieldCapacity: '人数',
    missingFieldLocation: '地点',
    missingFieldDesc: '简要描述',
    missingFieldFlow: '活动流程',
    missingFieldReq: '活动需求',
  },
  feedback: {
    title: '意见反馈',
    placeholder: '写下您的意见或建议...',
    submit: '提交反馈',
    myHistory: '我的反馈历史',
    noFeedbackYet: '您还没有提交过反馈',
    pendingReply: '待回复',
    replied: '已回复',
  },
  feedbackCollection: {
    title: '反馈收集箱',
    pending: '待处理',
    resolved: '已解决',
    officialReply: '官方回复',
    replyPlaceholder: '输入回复内容...',
    sendReply: '发送回复',
    noFeedback: '暂无任何反馈内容',
  },
  audit: {
    title: '审核状态',
    myApplications: '我的申请',
    addSchedule: '添加排期',
    selectClub: '搜索社团名称，点击选择',
    semester: '学期',
    block: '板块',
    venueName: '场地名称',
    add: '添加',
    clear: '清除',
    adminConsole: '管理员审核控制台',
    pendingClubs: '待审批社团',
    pendingActivities: '待审批活动',
    noApplications: '暂无申请',
    clickToReview: '点击查看详情并审核',
    approve: '通过',
    approveAll: '一键通过',
    approveAllConfirm: '确定一键通过全部 {n} 条申请？人数已满的社团将自动拒绝。',
    approveAllPerformanceConfirm: '确定一键通过全部 {n} 条演出选座申请？若座位已满，对应申请将按系统规则处理。',
    reject: '拒绝',
    adminRoleAssign: '管理员权限分配',
    searchUserPlaceholder: '输入用户姓名或 ID...',
    searchUserHint: '请输入姓名或用户ID进行搜索',
    noUserFound: '未找到匹配的用户',
    noMatchClub: '无匹配社团',
    venueManage: '场地管理',
    venueRequestReview: '场地申请审核',
    allSchedule: '全部排期',
    noSchedule: '暂无',
    statusPending: '待审核',
    statusApproved: '已通过',
    statusRejected: '已拒绝',
    myApplicationFeedback: '我的申请进度反馈',
    receivedActivityReg: '收到的活动报名申请',
    noActivityReg: '暂无活动报名',
    receivedClubJoin: '收到的社团加入申请',
    noClubJoin: '暂无社团申请',
    historyProgress: '历史进度追踪',
    applyJoinClub: '申请加入您的社团',
    applicationDetail: '申请详情',
    reviewDetailHint: '请审阅提交的详细信息以做出决策',
    approveApplication: '批准申请',
    rejectApplication: '拒绝申请',
    loadingServer: '正在连接服务器...',
    checkNetwork: '如果长时间无响应，请检查网络连接',
    loadFailed: '加载失败',
    retry: '重试',
    noData: '暂无数据',
    refresh: '刷新',
    applicantName: '申请人姓名',
    reason: '申请理由',
    contact: '联系方式',
    clubIntro: '社团介绍',
    activityContent: '活动内容',
    venue: '举办地点',
    venueTime: '举办时间',
    duration: '时长',
    weeks: '持续周数',
    capacity: '人数限制',
    briefDesc: '简要描述',
    flow: '活动流程',
    requirements: '活动需求',
    attachment: '附件',
    activityID: '活动 ID',
    paymentProof: '支付凭证',
    paymentStatus: '支付状态',
    viewAttachment: '点击查看/下载附件',
    viewImage: '查看大图',
    unpaid: '未支付',
    pendingVerification: '待审核',
    paid: '已支付',
    notFilled: '（未填写）',
    viewPaymentScreenshot: '查看支付截图',
    uploadedPaymentProof: '已上传支付凭证',
    noPaymentProof: '未上传支付凭证',
    reasonLabel: '申请原因',
    contactLabel: '联系方式',
    idRecoveryTitle: 'ID 找回请求处理',
    idRecoveryPending: '待处理的找回请求',
    idRecoveryResolved: '已处理的找回请求',
    idRecoveryNoPending: '暂无待处理请求',
    idRecoveryNoResolved: '暂无已处理记录',
    idRecoveryEmail: '邮箱',
    idRecoveryUserID: '预匹配到的用户ID',
    idRecoveryCopy: '复制ID',
    idRecoveryCopied: '已复制到剪贴板',
    idRecoveryMarkDone: '标记为已处理',
    idRecoveryHandledBy: '处理人',
    pinRecoveryTitle: 'PIN 找回请求处理',
    pinRecoveryPending: '待处理的找回请求',
    pinRecoveryResolved: '已处理的找回请求',
    pinRecoveryNoPending: '暂无待处理请求',
    pinRecoveryNoResolved: '暂无已处理记录',
    pinRecoveryHasPin: '该用户已设置PIN',
    pinRecoveryClearPin: '清除PIN并标记已处理',
  },
  login: {
    login: '登录',
    register: '注册',
    loginWithPin: '使用PIN登录',
    loginWithId: '使用ID登录',
    name: '姓名',
    class: '班级',
    userID: '用户ID',
    pinLabel: 'PIN（4-6 位数字）',
    pinPlaceholder: '请输入 4-6 位 PIN',
    error: '请填写完整登录信息',
    errorPin: '请填写姓名、班级和 PIN',
    errorId: '请填写姓名、班级和 ID',
    welcomeBack: '欢迎回来',
    createAccount: '创建新账号',
    namePlaceholder: '请输入姓名',
    classPlaceholder: '请输入班级',
    semesterClassHint: '新学期请填写当前班级。本学期首次登录会更新系统中的班级，之后需用新班级登录。',
    semesterClassUpdated: '已更新为本学期班级',
    idPlaceholder: '请输入您的 8 位 ID',
    idLabel: '唯一 ID',
    submitLogin: '立即登录',
    submitRegister: '提交注册',
    registerTip: '注册成功后系统将为您分配一个专属 ID，请务必妥善保存。',
    registerPinHint: '如填写 PIN 则下次登录只需填写 PIN，不需要 ID',
    forgotId: '找回ID',
    forgotPin: '找回PIN',
    forgotIdHint: '找回ID前请先确认已注册账号',
    forgotIdDesc: '如果忘记了自己的 ID，可以在这里提交申请，管理员会通过邮箱回复。',
    forgotPinHint: '找回PIN前请先确认已设置过 PIN',
    forgotPinDesc: '如果忘记了 PIN，可以在这里提交申请，管理员会清除您的 PIN，您可用 ID 登录后重新设置。',
    email: '邮箱',
    emailPlaceholder: '请输入常用邮箱（用于接收回复）',
    submitRecovery: '提交找回申请',
    recoverySuccess: '找回申请已提交，请等待管理员通过邮箱回复。',
    recoverySuccessAuto: '已向您填写的邮箱发送邮件，请查收（若未收到请查看垃圾箱）。',
    recoveryManualUserNotMatched: '未能根据姓名与班级自动匹配到账号，已提交人工处理，请等待管理员邮件联系。请确认姓名与注册时完全一致，班级尽量与系统登记一致。',
    recoveryManualSmtp: '服务器发信未配置完整，已转人工处理。请联系管理员检查 SMTP 环境变量。',
    recoveryManualMailFail: '自动发信失败，已转人工处理，请稍候或联系管理员。',
    recoveryFail: '提交找回申请失败，请稍后重试。',
    usePinLoginHint: '您设置了 PIN，请用 PIN 登录',
  },
};

export const en = {
  app: {
    tabs: {
      club: 'Clubs',
      activity: 'Activities',
      feedback: 'Feedback',
      feedbackCollection: 'Feedback Collection',
      audit: 'Audit Status',
    },
    search: {
      placeholder: 'Search user ID, club or activity...',
      button: 'Search',
      resultTitle: 'Search results',
      backHome: 'Back to home',
    },
    users: 'Users',
    clubs: 'Clubs',
    activities: 'Activities',
    noUsers: 'No matching users',
    noClubs: 'No related clubs',
    noActivities: 'No related activities',
    setAdmin: 'Set as admin',
    cancelRole: 'Revoke admin',
    save: 'Save',
    englishName: 'English name',
    logout: 'Logout',
    name: 'Name',
    class: 'Class',
    langSwitch: '中文',
  },
  common: {
    back: 'Back',
    cancel: 'Cancel',
    submit: 'Submit',
    confirm: 'Confirm',
    close: 'Close',
    save: 'Save',
    edit: 'Edit',
    delete: 'Delete',
    loading: 'Loading...',
    success: 'Success',
    fail: 'Failed',
    people: 'people',
    capacity: 'Capacity',
    full: 'Full',
    block: 'Block',
    clubs: ' clubs',
  },
  club: {
    menu: 'My clubs',
    wednesday: 'Wednesday clubs',
    wednesdayHint: '(max 4 slots, min 2 clubs)',
    daily: 'Daily clubs',
    notJoined: 'Not joined',
    usedSlots: 'Used',
    slotsTotal: '4 slots',
    needTwo: 'Select at least 2 Wednesday clubs',
    leave: 'Leave',
    rotation: 'Club rotation',
    rotationHint: 'Wednesday only',
    registration: 'Club registration',
    registrationHint: 'Daily / Wednesday',
    creation: 'Create club',
    backMenu: 'Back to menu',
    searchClub: 'Search club name, click to select',
    searchRotation: 'Search club name, click to replace',
    dailyClubs: 'Daily clubs (multiple allowed)',
    wednesdayClubs: 'Wednesday clubs (max 4 slots, min 2 clubs, one per slot)',
    noDaily: 'No daily clubs',
    noWednesday: 'No Wednesday clubs',
    join: 'Join',
    alreadyOrConflict: 'Selected or conflict',
    detail: 'Club details',
    participants: 'Participants',
    rollCall: 'Roll call',
    venue: 'Venue & schedule',
    downloadExcel: 'Download members Excel',
    dissolve: 'Dissolve club',
    closeDetail: 'Close',
    categoryTypeIntro: 'Category, type & intro',
    creator: 'Creator',
    actualLeader: 'Leader',
    proxyCreated: 'Proxy created by',
    wednesdayClub: 'Wednesday',
    dailyClub: 'Daily',
    both: 'Wed + Daily',
    academic: 'Academic',
    activityType: 'Activity',
    replaceWith: 'Replace with this club',
    quotaUsed: 'Quota used',
    resetQuota: 'Reset semester quota',
    replaceWhich: 'Select club to replace',
    replaceHint: 'Replace one of your Wednesday clubs with the selected one',
    rotationTime: 'Open: Sun 17:00 – Thu 21:50',
    semesterUsed: 'Rotations this semester',
    times: '',
    quotaExhausted: 'Semester rotation quota used. Wait for next semester.',
    needOneWednesday: 'Join at least one Wednesday club first',
    createApply: 'Apply to create club',
    blocks: 'Blocks',
    intro: 'Short intro...',
    content: 'Main content...',
    members: 'Members',
    coreMembers: 'Core members',
    viewDetail: 'View details',
    searchCoreMember: 'Search name or ID to add core member',
    noMembers: 'No members',
    introLabel: 'Intro',
    categoryLabel: 'Category',
    typeLabel: 'Type',
    blocksAndTime: 'Blocks & time',
    finalConfirm: 'Final confirm',
    finalConfirmMessage: 'Confirm your Wednesday club selection? After confirmation you cannot leave directly; changes must be made via club rotation.',
    finalConfirmDone: 'Confirmed. Use club rotation to make changes.',
    addUser: 'Add user',
    searchNameOrId: 'Search name or ID',
    add: 'Add',
    transferFounder: 'Transfer founder status',
    transfer: 'Transfer',
  },
  activity: {
    ongoing: 'Ongoing activities',
    searchActivity: 'Search activity name, click to register',
    noMatch: 'No matching activities',
    organizer: 'Organizer',
    youAreOrganizer: 'You are organizer',
    register: 'Register',
    registerTitle: 'Activity registration',
    reason: 'Reason',
    contact: 'Contact',
    participants: 'Participants',
    phase: 'Phase',
    location: 'Location',
    time: 'Time',
    description: 'Description',
    fee: 'Fee',
    paymentQR: 'Payment QR',
    payBefore: 'Scan to pay',
    uploadProof: 'Upload proof',
    deleteActivity: 'Delete activity',
    organize: 'Create activity',
    back: 'Back',
    organizeBtn: '1. Organize activity',
    registerBtn: '2. Activity registration',
    allActivitiesList: 'All activities',
    noActivities: 'No activities',
    phasePrep: 'Preparation',
    phaseStart: 'Start',
    phaseInProgress: 'In progress',
    phaseEnd: 'End',
    prepTime: 'Prep time',
    startTime: 'Start time',
    inProgressTime: 'In progress',
    endTime: 'End time',
    downloadParticipantsExcel: 'Download participants Excel',
    viewScreenshot: 'View screenshot',
    totalParticipants: '{count} participants',
    noParticipants: 'No participants',
    regActivity: 'Activity registration',
    joinClub: 'Join',
    organizeTitle: 'Create activity',
    requiredStarHint: 'Fields marked * are required.',
    activityNameLabel: 'Activity name',
    activityNamePlaceholder: 'Activity name',
    capacityLabel: 'Capacity limit',
    capacityPlaceholder: 'Capacity',
    locationLabel: 'Location',
    locationPlaceholder: 'Location',
    shortDescLabel: 'Short description',
    shortDescPlaceholder: 'Short description',
    flowLabel: 'Program / flow',
    flowPlaceholder: 'Program (no need for exact times)',
    requirementsLabel: 'Requirements',
    requirementsPlaceholder: 'Requirements',
    timeSectionTitle: 'Activity time',
    timeSectionHint: 'Required: start and end time (end must be after start).',
    startLabel: 'Start',
    endLabel: 'End',
    perfCheckboxLabel: 'This is a performance (numbered seats / ticketing)',
    perfCheckboxHint: 'After approval, configure zones, rows, seats and prices in Activity details. If you need online payment, enable fee below and upload a QR code.',
    feeOptionalLabel: 'Registration fee (optional)',
    feeAmountLabel: 'Fee amount',
    feeAmountPlaceholder: 'e.g. 50 CNY or 100 CNY',
    uploadQRLabel: 'Upload payment QR code',
    uploadQRHint: '(WeChat / Alipay)',
    uploadQRWarn: '⚠️ Please upload a payment QR code',
    attachmentOptional: 'Attachment (optional)',
    submitActivityApply: 'Submit activity application',
    introShort: 'Intro',
    confirmedSeats: 'Confirmed seats',
    mySeatPrefix: 'My seat: ',
    mySeatApproved: '(Confirmed)',
    mySeatPending: '(Pending)',
    feeInfoPrefix: '💰 Fee:',
    feeNotSet: 'Not set',
    editPerformanceSeats: 'Edit seat map',
    perfSeatTag: 'Performance · seats',
    perfSeatTagDetail: 'Performance · seats',
    perfChooseSeatTitle: 'This is a performance; use “Choose seat” on the right.',
    chooseSeatRegister: 'Choose seat',
    organizerColon: 'Organizer:',
    introColon: 'Intro:',
    deleteConfirm: 'Delete this activity? All participants will be removed.',
    deleted: 'Activity deleted',
    errLoadSeat: 'Failed to load seats',
    successLocksSaved: 'Holds saved',
    errSaveLocks: 'Save failed',
    errDownload: 'Download failed',
    errMinZoneRow: 'Add at least one zone and one row',
    errSeatZero: 'Zero seats; check seats per row',
    errBulkZone: 'Add at least one zone first',
    errBulkRange: 'Invalid row range or seats per row (≥1)',
    errSaveLayout: 'Save failed',
    errSaveLayoutOk: 'Seat map and holds saved',
    errUploadProofFirst: 'Upload payment screenshot first',
    uploadProofRequiredWarn: '⚠️ Please upload payment proof',
    reserveSubmitted: 'Seat request submitted; wait for organizer to confirm payment',
    reserveFail: 'Submit failed',
    errCapacityInt: 'Capacity must be an integer ≥ 1',
    errMissingPrefix: 'Please fill in: ',
    errNeedQRIfFee: 'Fee enabled: you must upload a payment QR code',
    errFillTime: 'Please set start and end time',
    errInvalidTime: 'Invalid time format',
    errEndAfterStart: 'End time must be after start time',
    activitySubmitted: 'Application submitted; pending approval',
    submitFail: 'Submit failed',
    errNeedFeeProof: 'This activity requires a fee; upload payment proof',
    regSubmitted: 'Registration submitted; pending organizer review',
    regFail: 'Registration failed',
    participantsLoadFail: 'Failed to load participants',
    updated: 'Updated',
    updateFail: 'Update failed',
    deleteFail: 'Delete failed',
    participantsTitle: 'Participants',
    participantsPageTitle: 'Participants - {name}',
    serialNo: '#',
    userIdCol: 'User ID',
    paymentProofCol: 'Payment proof',
    totalParticipantsLine: 'Total: {n} participants',
    performanceLockTitle: 'Hold seats (comps) · ',
    performanceBookTitle: 'Seats · ',
    backToList: 'Back to list',
    lockHelp: 'Click a seat to toggle open vs held (shown as sold). Seats with bookings cannot be changed; click occupied seats to see name/class. Then save.',
    bookHelp: 'One seat per user; after submitting you cannot pick another (pending or approved counts). If two people pick the same seat, the second gets “seat taken”.',
    myCurrentPick: 'Your seat:',
    pendingReview: '(Pending)',
    confirmed: '(Confirmed)',
    legendLock: 'Green: open · Purple: held (shown as sold) · Other: booked, locked',
    legendBook: 'Green: free · Orange: others pending · Yellow: your pending · Blue: yours · Gray: sold/held',
    legendOrg: 'Organizers: click occupied seats to see name and class.',
    loadingSeats: 'Loading seats…',
    saveLocksBtn: 'Save holds',
    currentReserved: 'Currently held: {n}',
    confirmSeatTitle: 'Confirm seat',
    seatLine: 'Seat: {z} Row {r} No.{s}',
    amountLine: 'Amount: ¥{p}',
    scanPayThenUpload: 'Pay via QR, then upload screenshot',
    submitRequest: 'Submit',
    holderTitle: 'Booker info',
    reviewStatusLabel: 'Status:',
    statusApproved: 'Approved',
    statusPending: 'Pending',
    nameLabelPlain: 'Name:',
    classLabelPlain: 'Class:',
    clickHolder: 'Click to see booker name and class',
    rowSuffix: 'Row ',
    seatCellHeld: 'T',
    seatCellPending: 'P',
    seatCellReserved: 'H',
    seatCellSold: 'S',
    regFormTitle: 'Register: {name}',
    detailTitle: 'Activity details - {name}',
    edit: 'Edit',
    notFilled: '(not set)',
    introHeading: 'Introduction',
    flowHeading: 'Program',
    reqHeading: 'Requirements',
    locationStrong: 'Location:',
    timeStrong: 'Time:',
    organizerStrong: 'Organizer:',
    peopleStrong: 'Headcount:',
    capacityUnlimited: '(no limit)',
    feeStrong: '💰 Fee:',
    mySeatDetail: 'My seat:',
    hintMapSeat: 'Open “Choose seat” to see the map.',
    reserveSeatsInternal: 'Hold seats (comps)',
    selectSeatToRegister: 'Choose seat',
    seatEditorTitle: 'Edit seats · {name}',
    seatStepLayout: '(1/2 layout)',
    seatStepPreview: '(2/2 preview & holds)',
    seatHowToTitle: 'How to:',
    seatHowTo1: 'Zones: name + price per seat.',
    seatHowTo2: 'Rows: add one row at a time or use bulk add below.',
    seatHowTo3: 'Next: mark comps (holds), then Save & publish so the public can book.',
    seatHowTo4: 'After publish you can still adjust holds via “Hold seats (comps)”.',
    zoneHeading: 'Zones',
    addZone: '+ Zone',
    newZoneDefault: 'New zone',
    zoneNameCol: 'Zone name',
    pricePerSeat: 'Price (per seat)',
    zoneNamePlaceholder: 'e.g. Floor 1',
    pricePlaceholder: 'Price',
    bulkTitle: 'Bulk add rows',
    bulkHint: 'In one zone, add rows from “from” to “to” with the same seats per row (row labels 1,2,3…).',
    bulkZone: 'Zone',
    rowFrom: 'From row',
    rowTo: 'To row',
    seatsPerRow: 'Seats/row',
    bulkAddBtn: 'Add rows',
    rowsManualTitle: 'Rows · seats (manual)',
    addOneRow: '+ Row',
    colBelongZone: 'Zone',
    colRowLabel: 'Row label',
    colSeatCount: 'Seats',
    rowPlaceholder: 'e.g. 1 or A',
    seatCountPlaceholder: 'Count',
    delete: 'Del',
    selectZoneTitle: 'Zone for this row',
    rowLabelTitle: 'Row label on map',
    seatCountTitle: 'Number of seats in this row',
    nextPreview: 'Next: preview & comps',
    previewHint: 'Click green/purple to toggle open vs hold. “Save & publish” saves map and holds together.',
    lockedCount: 'Holds: {n}',
    savePublish: 'Save & publish',
    prevStep: 'Back',
    seatToggleLockTitle: 'Click to hold',
    seatToggleOpenTitle: 'Click to open',
    feeInfoTitle: '💰 Registration fee',
    feeAmountStrong: 'Amount:',
    payScanLine: 'Scan to pay:',
    paymentScreenshot: 'Payment screenshot',
    fileSelected: '✅ File: {name}',
    submitRegister: 'Submit registration',
    editName: 'Name',
    editLoc: 'Location',
    editTime: 'Time',
    editTimePlaceholder: 'e.g. 2026/4/1 08:00 - 2026/4/8 09:00',
    editCapHint: 'Capacity (empty = no limit)',
    editDesc: 'Introduction',
    editFlow: 'Program',
    editReq: 'Requirements',
    feeCheckboxEdit: 'Charge registration fee',
    feeAmountEdit: 'Fee amount',
    feeExamplePlaceholder: 'e.g. 50 CNY',
    paymentQRAlt: 'Payment QR',
    fileSelectedShort: 'File selected',
    youAreOrganizerShort: 'You are organizer',
    excelNameFallback: 'Activity',
    participantsExcelSuffix: 'participants.xlsx',
    defaultZoneFloor: 'Floor 1',
    missingFieldActivityName: 'Activity name',
    missingFieldCapacity: 'Capacity',
    missingFieldLocation: 'Location',
    missingFieldDesc: 'Short description',
    missingFieldFlow: 'Program',
    missingFieldReq: 'Requirements',
  },
  feedback: {
    title: 'Feedback',
    placeholder: 'Your feedback...',
    submit: 'Submit',
    myHistory: 'My feedback history',
    noFeedbackYet: 'You have not submitted any feedback yet',
    pendingReply: 'Pending reply',
    replied: 'Replied',
  },
  feedbackCollection: {
    title: 'Feedback Collection',
    pending: 'Pending',
    resolved: 'Resolved',
    officialReply: 'Official Reply',
    replyPlaceholder: 'Enter reply content...',
    sendReply: 'Send Reply',
    noFeedback: 'No feedback yet',
  },
  audit: {
    title: 'Audit Status',
    myApplications: 'My applications',
    addSchedule: 'Add schedule',
    selectClub: 'Search club name, click to select',
    semester: 'Semester',
    block: 'Block',
    venueName: 'Venue name',
    add: 'Add',
    clear: 'Clear',
    adminConsole: 'Admin Audit Console',
    pendingClubs: 'Pending clubs',
    pendingActivities: 'Pending activities',
    noApplications: 'No applications',
    clickToReview: 'Click to view and review',
    approve: 'Approve',
    approveAll: 'Approve All',
    approveAllConfirm: 'Approve all {n} applications? Full clubs will be auto-rejected.',
    approveAllPerformanceConfirm: 'Approve all {n} seat reservations? If the venue is full, those requests are handled per system rules.',
    reject: 'Reject',
    adminRoleAssign: 'Admin role assignment',
    searchUserPlaceholder: 'Enter name or ID...',
    searchUserHint: 'Enter name or user ID to search',
    noUserFound: 'No matching users found',
    noMatchClub: 'No matching clubs',
    venueManage: 'Venue management',
    venueRequestReview: 'Venue request review',
    allSchedule: 'All schedules',
    noSchedule: 'None',
    statusPending: 'Pending',
    statusApproved: 'Approved',
    statusRejected: 'Rejected',
    myApplicationFeedback: 'My application progress',
    receivedActivityReg: 'Received activity registrations',
    noActivityReg: 'No activity registrations',
    receivedClubJoin: 'Received club join requests',
    noClubJoin: 'No club join requests',
    historyProgress: 'History progress',
    applyJoinClub: 'Request to join your club',
    applicationDetail: 'Application details',
    reviewDetailHint: 'Review the submitted details to make a decision',
    approveApplication: 'Approve',
    rejectApplication: 'Reject',
    loadingServer: 'Connecting to server...',
    checkNetwork: 'If no response, check your network',
    loadFailed: 'Load failed',
    retry: 'Retry',
    noData: 'No data',
    refresh: 'Refresh',
    applicantName: 'Applicant name',
    reason: 'Reason',
    contact: 'Contact',
    clubIntro: 'Club intro',
    activityContent: 'Activity content',
    venue: 'Venue',
    venueTime: 'Time',
    duration: 'Duration',
    weeks: 'Weeks',
    capacity: 'Capacity',
    briefDesc: 'Description',
    flow: 'Flow',
    requirements: 'Requirements',
    attachment: 'Attachment',
    activityID: 'Activity ID',
    paymentProof: 'Payment proof',
    paymentStatus: 'Payment status',
    viewAttachment: 'View/Download attachment',
    viewImage: 'View full size',
    unpaid: 'Unpaid',
    pendingVerification: 'Pending verification',
    paid: 'Paid',
    notFilled: '(Not filled)',
    viewPaymentScreenshot: 'View payment screenshot',
    uploadedPaymentProof: 'Payment proof uploaded',
    noPaymentProof: 'No payment proof uploaded',
    reasonLabel: 'Reason',
    contactLabel: 'Contact',
    idRecoveryTitle: 'ID recovery requests',
    idRecoveryPending: 'Pending ID recovery',
    idRecoveryResolved: 'Resolved ID recovery',
    idRecoveryNoPending: 'No pending requests',
    idRecoveryNoResolved: 'No resolved requests',
    idRecoveryEmail: 'Email',
    idRecoveryUserID: 'Matched User ID',
    idRecoveryCopy: 'Copy ID',
    idRecoveryCopied: 'Copied to clipboard',
    idRecoveryMarkDone: 'Mark as resolved',
    idRecoveryHandledBy: 'Handled by',
    pinRecoveryTitle: 'PIN recovery requests',
    pinRecoveryPending: 'Pending PIN recovery',
    pinRecoveryResolved: 'Resolved PIN recovery',
    pinRecoveryNoPending: 'No pending requests',
    pinRecoveryNoResolved: 'No resolved requests',
    pinRecoveryHasPin: 'User has PIN set',
    pinRecoveryClearPin: 'Clear PIN and mark resolved',
  },
  login: {
    login: 'Login',
    register: 'Register',
    loginWithPin: 'Login with PIN',
    loginWithId: 'Login with ID',
    name: 'Name',
    class: 'Class',
    userID: 'User ID',
    pinLabel: 'PIN (4-6 digits)',
    pinPlaceholder: 'Enter 4-6 digit PIN',
    error: 'Please fill in all fields',
    errorPin: 'Please fill name, class and PIN',
    errorId: 'Please fill name, class and ID',
    welcomeBack: 'Welcome back',
    createAccount: 'Create account',
    namePlaceholder: 'Enter name',
    classPlaceholder: 'Enter class',
    semesterClassHint: 'Enter your current class. The first login each term updates your class on the site; later logins must use the new class.',
    semesterClassUpdated: 'Class updated for this term',
    idPlaceholder: 'Enter your 8-digit ID',
    idLabel: 'User ID',
    submitLogin: 'Log in',
    submitRegister: 'Register',
    registerTip: 'After registration you will receive a unique ID. Please save it.',
    registerPinHint: 'If you set a PIN, next login only needs PIN (no ID required)',
    forgotId: 'Forgot ID?',
    forgotPin: 'Forgot PIN?',
    forgotIdHint: 'Please confirm you have registered before recovering your ID',
    forgotIdDesc: 'If you forgot your ID, submit a request here and an admin will email it to you.',
    forgotPinHint: 'Please confirm you have set a PIN before recovering',
    forgotPinDesc: 'If you forgot your PIN, submit a request. Admin will clear it; you can then login with ID and set a new PIN.',
    email: 'Email',
    emailPlaceholder: 'Enter your email (for admin reply)',
    submitRecovery: 'Submit recovery request',
    recoverySuccess: 'Request submitted. Please wait for admin to reply via email.',
    recoverySuccessAuto: 'An email has been sent to the address you entered. Check your inbox or spam folder.',
    recoveryManualUserNotMatched: 'We could not match your name and class to an account. Your request was sent for manual review. Make sure your name matches registration exactly.',
    recoveryManualSmtp: 'Email is not fully configured on the server; request sent for manual review. Ask an admin to check SMTP settings.',
    recoveryManualMailFail: 'Automatic email failed; request sent for manual review.',
    recoveryFail: 'Failed to submit request. Please try again later.',
    usePinLoginHint: 'You have set a PIN. Please login with PIN.',
  },
};
